import { Date } from '../typo/Typo'


const CardEvent = props => {
    return (
        <div className="card card-events">
            <div className="card-placeholder ratio ratio-3x2">
                <div className="card-events--location">
                    <i className="bi bi-geo-alt-fill"></i>
                    <p>{props.location}</p>
                </div>
            </div>
            <div className="card-body">
                <h5 className="card-title">
                    <a href="#!" className="title-link">{props.title}</a>
                </h5>
                <Date>{props.date}</Date>
                <p className="card-text">{props.body}</p>
            </div>
        </div>
    );
}
  
export default CardEvent;